import { cn } from '../../../../cn/cn';

export type ToastVertical = 'top' | 'bottom';
export type ToastHorizontal = 'left' | 'center' | 'right';

/**
 * Where a toast sits. `z-50` is one rung above dialogs and menus, so a toast
 * from a form in a dialog shows above it (`dialogClasses` has the scale).
 *
 * On a phone the box spans the width with 8px margins; from 600px it shrinks to
 * its content at the chosen corner.
 *
 * The 56px under a top toast clears the app bar. It is tied to the top anchor
 * because the top-anchored apps need it and bottom-anchored app-customer must
 * not have it.
 */
const BASE =
  'fixed z-50 flex items-center justify-center left-2 right-2 pointer-events-none';

const VERTICALS: Record<ToastVertical, string> = {
  top: 'top-2 mt-14 sm:top-6',
  bottom: 'bottom-2 sm:bottom-6',
};

const HORIZONTALS: Record<ToastHorizontal, string> = {
  left: 'sm:left-6 sm:right-auto',
  center: 'sm:left-1/2 sm:right-auto sm:-translate-x-1/2',
  right: 'sm:right-6 sm:left-auto',
};

export const toastViewportClasses = ({
  vertical,
  horizontal,
  className,
}: {
  vertical: ToastVertical;
  horizontal: ToastHorizontal;
  className?: string;
}): string => cn(BASE, VERTICALS[vertical], HORIZONTALS[horizontal], className);
